import React from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./whattoexpectmodal.scss";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
const applicationSteps = [
  {
    heading: "Before you start and pre-application checks",
    description: `<p>
    We’ll first ask whether you have considered shopping around, are aware of the risks of your potential choices, pension scams and tax implications of your decisions.
  </p>
  <p>
    Sometimes we’ll need to do some extra checks. If these apply we’ll create a personalised pack for you and let you know when it’s ready to view and download:
  </p>
  <ul class="no-bullets">
    <li>
      <strong>Protected tax-free cash</strong>
      <br />
      Extra calculations in case you’re entitled to more than 25% tax-free cash.
    </li>
    <li>
      <strong>Paying your pension within tax allowances</strong>
      <br />
      If you have received or are about to receive substantial retirement lump sums from other UK pension schemes, we’ll need details of these benefits.
    </li>
  </ul>
  <p>
    <strong>Guidance and advice</strong>
    <br />
    Before you get started on the main part of your application, we’ll need you to confirm if you’ve taken up a free Pension Wise appointment, or have decided not to.
  </p>`,
    time: "3 MINS",
  },
  {
    heading: "Your TPT pot",
    description: `<p>Choose how much of your TPT pension pot you want to use and, if you have more than one pot, which pot(s) you’d like to use.</p>
    <p>
      <strong>Handy tip</strong>
      <br />
      If you want to mix and match, select the total value that you wish to take here (rather than making separate applications).
    </p>`,
    time: "2 MINS",
  },
  {
    heading: "Your retirement choice",
    description: `<p>Let us know how you want to use your TPT pension pot. You have several options, and you can mix and match them.</p>
    <p>
    <strong>What you’ll need</strong>
    <br />
    <div>
      <ul class="with-bullets">
        <li>If you’re choosing an annuity, we’ll need the name of your annuity provider and, if you have one, a reference number.</li>
        <li>Please make sure your provider or adviser sends us full payment details so we can process your application (or you can upload these at the ‘get in touch’ page).</li>
      </ul>
    </div>
  </p>`,
    time: "4 MINS",
  },
  {
    heading: "Your illustration",
    description: `<p>Your illustration(s) show how your retirement choices will affect your TPT pension pot. Please review these and confirm that you’re happy to continue.</p>`,
    time: "2 MINS",
  },
  {
    heading: "Your bank details",
    description: `<p>We’ll need your bank details to send your pension payment. The account must be in your name (or you must be named as a joint account holder).</p>`,
    time: "2 MINS",
  },
  {
    heading: "Verifying your identity",
    description: `<p>We’ll check your identity before we can make any pension payment to you.</p>
    <p>
    <strong>What you’ll need</strong>
    <br />
    You must bring a photo ID (e.g., passport or driver's license) and a mobile phone, as we’ll take a selfie—it doesn’t have to be your own phone.
  </p>`,
    time: "4 MINS",
  },
  {
    heading: "Declaration and submission",
    description: `<p>Please check everything is correct before continuing.</p>
    <p>Click submit, and you’re all done!</p>`,
    time: "3 MINS",
  },
  {
    heading: "What next?",
    description: `<p>Once you’ve submitted your application, it can take as little as eight working days for us to process your application and get your money to you. Some important points to note are: </p>
    <ul class="with-bullets">
      <li>We may contact you with some follow-up questions to ensure your secure payment.</li>
      <li>Tax-free cash and annuities are paid at the same time, so please ensure we have full payment instructions from your annuity provider so we can process your application. </li>
      <li>If you are stopping contributions, we must receive your final contribution before we can finalise your application.</li>
      <li>If you mix and match, we may pay your tax-free cash before any additional taxable lump sum. </li>
      <li>If you send paperwork in the post,  then it takes longer, but usually no more than eight weeks.</li>
    </ul>
    <p><strong>We strongly recommend that you do not make any financial commitments until you receive your pension.</strong></p>`,
  },
];
const WhatToExpect = (props) => {
  return (
    <div className="what-to-expect-modal">
      <div className="text-end">
        <Icons
          iconname="close-large"
          variant="icon-sixteen-px"
          clickHandler={props.handleCloseButton}
        />
      </div>
      <div className="heading mt-2 mb-4">What to expect</div>
      <div className="sub-text">
        <p>
          This TPT online retirement application tool takes you step by step
          through the application process if you wish to take your pension from
          TPT and/or buy an annuity.
        </p>
        <p>
          You can go back and change any of the information you’ve entered any
          time you like, right up until you hit the ‘submit’ button.
        </p>
        <p>
          Your progress will automatically be saved at the end of each section
          (apart from bank details). It’ll be kept for 30 days and you can sign
          back in and continue your application any time during that period.
        </p>
      </div>

      <div className="mt-2 mb-2">
        <strong>Top tips:</strong>
      </div>
      <div className="sub-text">
        <ul>
          <li className="top-tips-list">
            Ensure that your{" "}
            <strong>
              <Link to="/account-details" className="account-details-link">
                personal details
              </Link>
            </strong>{" "}
            are correct before starting this application, as we will verify your
            identity as part of this process.
          </li>
          <li className="top-tips-list">
            If you’re stopping contributions, please ask your employer to inform
            us as soon as possible that you’re leaving the scheme. The final
            contribution from your employer may be up to three weeks after the
            month you leave. Please allow extra time for your application to be
            processed.
          </li>
          <li className="top-tips-list">
            <strong>
              If you prefer to transfer your pension out of TPT to move it to
              another provider, please use the ‘Leaving TPT’ tab above.
            </strong>
          </li>
          <li className="top-tips-list">
            Pension values will go up and down and this application will display
            current values only.
          </li>
        </ul>
      </div>

      <div className="application-steps-desc">
        {applicationSteps?.map((item, index) => (
          <>
            <Row key={index}>
              <Col xl={3} lg={3} md={4} className="item-index-container">
                <p className="item-index">{index + 1}</p>
                <p className="item-heading">{item?.heading}</p>
              </Col>
              <Col xl={7} lg={7} md={8} className="item-description">
                <div
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                ></div>
              </Col>
              <Col xl={2} lg={2} className="item-time">
                {item?.time ? (
                  <span className="align-right">
                    <Icons iconname="clock" variant="icon-sixteen-px me-2" />
                    {item?.time}
                  </span>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            {applicationSteps?.length !== index + 1 ? <hr /> : ""}
          </>
        ))}
        <div className="footer-description">
          <p>
            If you’re unsure about anything, please seek independent guidance or
            financial advice.
          </p>
        </div>
        <Buttons
          className="primary"
          name="Got it!"
          handleClick={props.handleCloseButton}
        />
      </div>
    </div>
  );
};

export default WhatToExpect;
